
    <h4
      *ngIf="!loading && data && data.length === 0"
      class="text-center padding-16"
    >
      {{ message | translate }}
    </h4>
  